import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative bg-[#FAFAF8] pt-32 pb-20 overflow-hidden">
      <div className="absolute top-0 right-0 w-1/3 h-full opacity-10">
        <svg viewBox="0 0 400 400" className="w-full h-full">
          <path d="M50 50 L350 50 L350 350" stroke="currentColor" strokeWidth="2" fill="none" />
          <circle cx="100" cy="100" r="30" stroke="currentColor" strokeWidth="2" fill="none" />
          <rect x="200" y="150" width="100" height="100" stroke="currentColor" strokeWidth="2" fill="none" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3 space-y-8">
            <h1 className="text-6xl lg:text-7xl font-bold text-gray-900 leading-tight">
              Launch Your<br />Business in<br />El Paso
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed max-w-xl" style={{ lineHeight: '1.8' }}>
              Access comprehensive resources, local regulations, networking opportunities, and expert guidance to successfully start your business in El Paso, Texas.
            </p>
            <Link
              to="/guides"
              className="inline-flex items-center space-x-3 bg-[#D2691E] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#B8571A] transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <span>Get Started Today</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </div>

          <div className="lg:col-span-2">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#FAFAF8]/30 rounded-3xl"></div>
              <img
                src="https://public.readdy.ai/ai/img_res/eb12aedd4ff50c6f5bb69165bfd8aa53.jpg"
                alt="El Paso Business District"
                className="w-full h-auto rounded-3xl shadow-2xl object-cover"
                style={{ width: '600px', height: '700px' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}